export const OBJECT_ID = 'objectId';
export const SCREEN_NAME = 'screenName';
export const ORGANIZATION_ID = 'organizationId';
export const BUILDING_ID = 'buildingId';
export const ROOM_ID = 'roomId';
export const USER_ID = 'userId';
export const ARS_ORGANIZATION_ID = 'organizationId';
